import { Button, FormDescription, Loader } from 'legacy-components/componets';
import { ConnectAccountManagement, ConnectComponentsProvider, ConnectNotificationBanner, ConnectPayments, ConnectPayouts } from '@stripe/react-connect-js';
import { HorizontalTabPanel, TabInfo } from 'components/organisms';
import { useStripeOnboarding } from 'legacy-pages/landlord/profile/context/StripeOnboardingProvider';
import { useState } from 'react';

const LandlordPayoutDetails = () => {
  const [isLoading, setIsLoading] = useState(false);
  const {
    stripeConnectInstance,
    connectedAccountId,
    isConnectedAccountOnboarded,
    isGetConnectedAccountPending,
    isConnectedAccountPending,
    handleCreateConnectedAccount,
    OnboardingComponent,
  } = useStripeOnboarding();

  if (isGetConnectedAccountPending) {
    return <Loader />
  }

  const payoutTabs: TabInfo[] = [
    {
      label: 'Payouts',
      content: <ConnectPayouts />,
    },
    {
      label: 'Payments',
      content: <ConnectPayments />
    },
    {
      label: 'Account Management',
      content: <ConnectAccountManagement />,
    },
  ];

  return (
    <div className='flex flex-1 flex-col gap-9'>
      <div className='personal-details px-4 md:px-9 py-6 shadow-white-xl'>
        <div className='mb-4'>
          <FormDescription title={'Payout'} />
        </div>
        {isLoading && <Loader />}
        {!isConnectedAccountOnboarded && <OnboardingComponent onLoaderStart={() => setIsLoading(false)} />}

        {stripeConnectInstance && isConnectedAccountOnboarded && (
          <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
            <div className='mb-4'>
              <ConnectNotificationBanner />
            </div>
            <HorizontalTabPanel tabs={payoutTabs} />
          </ConnectComponentsProvider>
        )}

        {!connectedAccountId && (
          <Button
            label={'Add payout information'}
            theme={'primary'}
            onClick={handleCreateConnectedAccount}
            isFullWidth
            isLoading={isGetConnectedAccountPending || isConnectedAccountPending}
          />
        )}
      </div>
    </div>
  );
};

export default LandlordPayoutDetails;